import React from 'react'
import Main from '../components/InfoPage/Main'

const InfoPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default InfoPage